import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ServiceTemplate } from 'src/app/models/interface/serviceTemplate/serviceTemplate';
import { ServiceTemplateRequest } from 'src/app/models/interface/serviceTemplate/serviceTemplateRequest';
import { CatalogService } from 'src/app/services/api/catalog/catalog.service';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { TemplatesService } from 'src/app/services/api/templates/templates.service';
import { BreadcrumbsService } from 'src/app/services/utils/breadcrumbs.service';

@Component({
  selector: 'app-new-service-template',
  templateUrl: './new-service-template.component.html',
  styleUrls: ['./new-service-template.component.scss']
})
export class NewServiceTemplateComponent implements OnInit {

  form: FormGroup;

  tooltip = {
    submit: '',
    clear: ''
  }

  serviceName: string;

  serviceTemplateCharValues: any[];
  subscription: Subscription;

  serviceTemplates: ServiceTemplate[];

  specs: any[];

  constructor(
    private formBuilder: FormBuilder,
    private breadcrumbsService: BreadcrumbsService,
    private router: Router,
    private translate: TranslateService,
    private templatesService: TemplatesService,
    private route: ActivatedRoute,
    private notificationsService: NotificationsService,
    private catalogService: CatalogService,
    private translateService: TranslateService
  ) {

  }

  ngOnInit() {
    this.serviceTemplateCharValues = [];
    this.breadcrumbsService.sendBreadcrumbs(
      {
        breadcrumbs:
          [
            { title: 'Administración', url: 'provision/management' },
            { title: 'Nuevo ServiceTemplate FTTH', url: 'provision/management/serviceTemplates/new' }
          ]
      }
    );

    this.form = new FormGroup({
      serviceTemplateName: new FormControl('', Validators.required),
      version: new FormControl('', Validators.required),
      spec: new FormControl('', Validators.required)
    });

    this.serviceName = '';
    this.catalogService.getServiceTemplateSpec().subscribe(
          data => {
            this.specs = [...data];
          },);
    this.calcularChars();
    
  }

  public calcularChars(){
    this.catalogService.getCustomServiceSpec(this.form.controls['spec'].value).subscribe(data => {
      var sortedServiceSpecServiceChars = data.serviceSpecServiceChars.sort((a,b) =>
      a.serviceCharRef.namingId.toLowerCase() < b.serviceCharRef.namingId.toLowerCase() ? -1 : 1 );
      for (let serviceChar of sortedServiceSpecServiceChars) {
        const validators = serviceChar.mandatory ? [Validators.required] : [];
        this.form.addControl(serviceChar.serviceCharRef.namingId, new FormControl('', validators))
      }
      this.serviceTemplateCharValues = data.serviceSpecServiceChars;
    })
  }

  public submitForm() {

    const serviceTemplateRequest: ServiceTemplateRequest = {
      namingId: "Profile_" + this.form.controls['serviceTemplateName'].value + "_v" + this.form.controls['version'].value,
      name: this.form.controls['serviceTemplateName'].value,
      version: this.form.controls['version'].value,
      specId: "NetworkProfileSpec_v" + this.form.controls['version'].value,
      state: 'ACTIVE',
      serviceTemplateCharValues: []
    };

    for (const serviceTemplateCharValue of this.serviceTemplateCharValues) {
      serviceTemplateRequest.serviceTemplateCharValues.push({
        value: this.form.controls[serviceTemplateCharValue.serviceCharRef.namingId].value,
        name: serviceTemplateCharValue.serviceCharRef.namingId
      })
    }

    this.catalogService.createServiceTemplate(serviceTemplateRequest).subscribe(
      () => {
        this.notificationsService.showNotification(`El ServiceTemplate ${serviceTemplateRequest.name} se ha creado correctamente`, NotificationLevel.SUCCESS);
        this.router.navigate([`/provision/management/serviceTemplates/search`]);
      },
      (error) => {
        this.notificationsService.showNotification(
          `Ha habido un problema al crear el template:\n${error.error.errorDesc.errorDesc}`, NotificationLevel.ERROR);
        this.router.navigate([`/provision/management/serviceTemplates/search`]);
      });
  }

  public goToSearchTemplates() {
    this.router.navigate([`/provision/management/serviceTemplates/search`]);
  }

  public clearForm() {
    this.form.reset();
  }


}
